export default "__VITE_ASSET__AgilOr$4__"